import { render, staticRenderFns } from "./IBeaconMessageListPage.vue?vue&type=template&id=88b4c806&scoped=true"
import script from "./IBeaconMessageListPage.vue?vue&type=script&lang=js"
export * from "./IBeaconMessageListPage.vue?vue&type=script&lang=js"
import style0 from "./IBeaconMessageListPage.vue?vue&type=style&index=0&id=88b4c806&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88b4c806",
  null
  
)

export default component.exports